import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ComingSoonSteps({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>

          <Col span={24}>
            <h3 className="pink-info-text">
              Send this email to the owner in sayeagle -{" "}
              <strong className="red-info-heading">
                put the address in the subject line
              </strong>
            </h3>
          </Col>
          <Col span={24}>
            <p>
              We will be assessing the property for needed repairs or cleaning
              prior to showing. If it is left in show ready condition we will
              list it for showings right away. If work is needed we will list it
              as coming soon while the needed work is done. In the meantime as
              we get ready to list we wanted to ask a few questions of you.
            </p>
          </Col>
          <Col span={24}>
            <p>
              1. Do you want one of our Make Ready vendors to get you an
              estimate for getting the home ready for rent again if work is
              needed.
            </p>
          </Col>
          <Col span={24}>
            <p>
              2. What rate would you like it listed for? We always recommend
              listing close to the prices of active listings in your area that
              are found online. We do recommend lowering by $25 every 2 weeks if
              needed. If you would like guidance on a listing price let me know
              and i can pull some comps for you to check out. Let me know what
              you think and I'll be listing it soon.
            </p>
          </Col>
          <Col span={24}>
            <p>
              3. Do you want to accept section 8 (housing vouchers ) for your
              property? Please be aware there is an additional fee for section 8
              listings due to the needed inspections and there is also generally
              a delay of 1 to 3 months for a tenant on section 8 to move into a
              home. There is an additional fee of $75 for each section 8 or
              staff inspection required during the section 8 leasing, renewal or
              biannual inspection process. Be aware that EVERY section 8
              inspection will require a repair and these can range from as small
              as $100 to up to several THOUSAND in repairs. If you are unsure on
              this please reach out to me but generally we do not recommend it
              due to some of these issues.
            </p>
          </Col>
          <Col span={24}>
            <p>
              4. Do you want to allow pets? Please know if an applicant has a
              service or emotional support animal/service animal we must allow
              it.
            </p>
          </Col>
          <Col span={24}>
            <p>
              5.If you are a long term owner with us let us know if you would
              like to participate in our Pet Damage Guarantee program. This
              program will protect you for up to $1000 in pet damage if you opt
              in. Owners that have signed on during our last year and are on our
              flat fee plan are already on this plan already but if you have
              questions just reach out to Rhett@integrityokc.com
            </p>
          </Col>
          <Col span={24}>
            <p>
              6. Are there any utilities you pay that you would like to bill
              back to the tenant or have the tenant pay a portion of if this is
              a multi family property? We will calculate a flat fee to bill the
              tenant monthly that will be approx. 1/2 of your average bill for
              the past 12 months for any shared utilities.
            </p>
          </Col>
          <Col span={24}>
            <p>
              7. Have any changes or improvements been made to the property that
              you want to emphasize in the listing?
            </p>
          </Col>
          <Col span={24}>
            <p>
              8. Would you like professional pictures? we have a service that
              does this for around $175 and these could be used each time we
              list your home again.
            </p>
          </Col>
          <Col span={24}>
            <p>
              9. If you have not done so in the past please fill out this
              property information form which we use during the listing process.
              <span className="onclick-text">
                https://form.jotform.com/220879186346063
              </span>
            </p>
          </Col>
          <Col span={24}>
            <p>
              10. We may list your property as accepting our Security Deposit
              Waiver Program. This program will enable you to collect up to 100%
              of the monthly rent for any damages caused by a tenant at move
              out. If the tenant opts to pay the security deposit then it would
              be the normal one month's rent
            </p>
          </Col>
          <Col span={24}>
            <p>
              Please Note: to continue to stay compliant with federal fair
              housing guidelines. Our staff will be making the approval decision
              instead of reaching out to owners for the final authorization. We
              will always keep you posted of the process and are happy to answer
              any questions you have along the way. As always our goal is to get
              the best tenant we can for your property. A great tenant makes our
              life easier and your profits increase!
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
            If owner requests feedback on how to price refer to active listings on this site - https://www.zillow.com/rental-manager/price-my-rental/
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Completed</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ComingSoonSteps;
